import * as types from './ShareLinksActionType';

export const fetchShareLinksRequest = (includeRevoked = false) => ({
    type: types.FETCH_SHARE_LINKS_REQUEST,
    payload: { includeRevoked },
});
export const fetchShareLinksSuccess = (data) => ({ type: types.FETCH_SHARE_LINKS_SUCCESS, payload: data });
export const fetchShareLinksFailure = (error) => ({ type: types.FETCH_SHARE_LINKS_FAILURE, payload: error });

export const revokeLinkRequest = (shareLinkId, includeRevoked = false) => ({ type: types.REVOKE_LINK_REQUEST, payload: { shareLinkId, includeRevoked } });
export const revokeLinkSuccess = () => ({ type: types.REVOKE_LINK_SUCCESS });
export const revokeLinkFailure = (error) => ({ type: types.REVOKE_LINK_FAILURE, payload: error });

export const generateLinkRequest = (payload) => ({ type: types.GENERATE_LINK_REQUEST, payload });
export const generateLinkSuccess = (token) => ({ type: types.GENERATE_LINK_SUCCESS, payload: token });
export const generateLinkFailure = (error) => ({ type: types.GENERATE_LINK_FAILURE, payload: error });
export const clearGeneratedLink = () => ({ type: types.CLEAR_GENERATED_LINK });
